module.exports = __webpack_public_path__ + "assets/82ae7337857fa73aa65139c24585018b.mp3";